import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import {
  formatDateDDMMYY,
  formatDateFilterApi,
  formatDateFilterView,
} from "../../utils/dateFormatter";
import { FilterItem, FilterItemType } from "../filters/filters.types";
import { PuObrazac, PuObrazacListPayload } from "./poreskaUprava.types";

export const PU_OBRASCI_LIST_INITIAL_FILTERS = {
  pib: null,
  brojJCI: null,
  datum: null,
  pibSpeditera: null,
};

export const getPUObrasciFilterItems = ({
  hiddenFilters,
  isLoading,
}: {
  isLoading?: boolean;
  hiddenFilters?: Array<keyof PuObrazacListPayload>;
}): Array<FilterItem<PuObrazacListPayload>> => {
  const filters = [
    {
      fieldName: "pib",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("PLACEHOLDERS.PIB"),
        loading: isLoading,
      },
    },
    {
      fieldName: "brojJCI",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("PLACEHOLDERS.BROJ_JCI"),
      },
    },
    {
      fieldName: "pibSpeditera",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("PLACEHOLDERS.PIB_SPEDITERA"),
      },
    },
    {
      fieldName: "datum",
      type: FilterItemType.DATE,
      props: {
        placeholder: t("PLACEHOLDERS.DATUM"),
      },
      formatForApi: formatDateFilterApi,
      formatForClient: formatDateFilterView,
    },
  ];
  return filters.filter(
    (filter) =>
      !hiddenFilters?.includes(filter.fieldName as keyof PuObrazacListPayload)
  ) as Array<FilterItem<PuObrazacListPayload>>;
};

export const getPuObrasciTableColumns = ({
  hiddenColumns,
}: {
  hiddenColumns: Array<keyof PuObrazac>;
}) => {
  const columns = [
    {
      title: t("PU_OBRASCI.PIB"),
      dataIndex: "pibUvoznika",
    },
    {
      title: t("PU_OBRASCI.BROJ_JCI"),
      dataIndex: "brojJCI",
    },
    {
      title: t("COMMON.DATUM"),
      dataIndex: "datum",
      render: (date: string) => formatDateDDMMYY(date),
    },
    {
      title: t("PU_OBRASCI.PIB_SPEDITERA"),
      dataIndex: "pibSpeditera",
    },
  ];
  return columns.filter(
    (column) => !hiddenColumns.includes(column.dataIndex as keyof PuObrazac)
  ) as ColumnsType<PuObrazac>;
};
